import React, { useCallback, useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { AddRealestateModalList } from "./list/AddRealestateModalList";
import { RootStoreContext } from "src/stores/RootStore";
import { t } from "i18next";
import { ErpType } from "src/network/User";

export interface AssemblyAddRealestateList {
    id?: string;
    name?: string;
    number?: string;
    consolidationid?: string;
}

const AddAssemblyRealestateModalBase = () => {
    const { realestateStore, assemblyStore, uiStore, authStore } = useContext(RootStoreContext);

    useEffect(() => {
        async function initializeAssemblyData() {
            await realestateStore.loadRealestatesCondominium(authStore.user?.erpType === ErpType.IT2);
        }
        initializeAssemblyData();
        // eslint-disable-next-line
    }, []);

    const realestateItems: AssemblyAddRealestateList[] = [];

    const realestatesDataCondominium =
        authStore.user?.erpType === ErpType.IT2
            ? realestateStore.realestatesCondominiumIT2
            : realestateStore.realestatesCondominium;

    const alreadyAddedAssemblyRealestateIds = assemblyStore.currentAssemblyRealestates.map(
        (assemblyrealestate) => assemblyrealestate.realestate.id
    );

    realestatesDataCondominium.forEach((realestate) => {
        const realestateToAdd: AssemblyAddRealestateList = {
            id: realestate.id,
            name: realestate.name ?? "",
            number: realestate.number ?? "",
            consolidationid: realestate.consolidationid ?? ""
        };

        if (!alreadyAddedAssemblyRealestateIds?.includes(realestateToAdd.id ?? "")) {
            realestateItems.push(realestateToAdd);
        }
    });

    const onCloseModal = useCallback(() => {
        assemblyStore.setIsAddAssemblyRealestateModalDisplayed(false);
    }, [assemblyStore]);

    const Content = (props: { children: React.ReactNode }) => {
        return <AddRealestateModalList realestates={realestateItems} />;
    };

    return (
        <UI.Modal
            title={t("screens.realestate.assembly.add_realestate").toString()}
            show={assemblyStore.isAddAssemblyRealestateModalDisplayed}
            centered={uiStore.isMobile ? true : false}
            size={uiStore.isMobile ? undefined : "lg"}
            onClose={onCloseModal}
        >
            <Content children={undefined}></Content>
        </UI.Modal>
    );
};

export const AddAssemblyRealestateModal = Sentry.withProfiler(observer(AddAssemblyRealestateModalBase));
